import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { setValue, fetchGroupCategories, fetchSuggestedProdNum, fetchProductsByCategory,
  fetchSuggestDigit, clearSuggestDigit, updateProductGroup, fetchProductDetail } from '../../actions/products_actions';
import { EditGroupForm } from '../../components/Products/editGroupForm';

const editGroupForm = reduxForm({
  form: 'editGroupForm',
})(EditGroupForm);

const selector = formValueSelector('editGroupForm');

function mapStateToProps(state) {
  const Category = selector(state, 'Category');
  const Group = selector(state, 'Group');
  const IsLarge = selector(state, 'IsLarge');
  const LastDigit = selector(state, 'LastDigit');
  const Name = selector(state, 'Name');
  const Description = selector(state, 'Description');
  const isMadePrev = selector(state, 'isMadePrev');
  return {
    Category,
    Group,
    IsLarge,
    LastDigit,
    Name,
    Description,
    isMadePrev,
    existingProd: state.products.all,
    existingProdError: state.products.error,
    existingProdIsLoading: state.products.isLoading,
    fetchingSuggestedProdNum: state.products.fetchingSuggestedProdNum,
    suggestedProdNumFetched: state.products.suggestedProdNumFetched,
    suggestedProdNumFetchError: state.products.suggestedProdNumFetchError,
    groupCategories: state.products.groupCategories,
    groupCategoryError: state.products.groupCategoryError,
    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
    fetchingSuggestDigit: state.products.fetchingSuggestDigit,
    suggestDigitFetched: state.products.suggestDigitFetched,
    suggestDigitFetchError: state.products.suggestDigitFetchError,
    updateProduct: state.products.updateProduct,
    updateProductIsLoading: state.products.updateProductIsLoading || state.products.isCreating,
    updateProductError: state.products.error,
  };
}

export default connect(mapStateToProps, {
  setValue,
  fetchGroupCategories,
  fetchSuggestedProdNum,
  fetchProductsByCategory,
  fetchSuggestDigit,
  clearSuggestDigit,
  updateProductGroup,
  fetchProductDetail,
})(editGroupForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/editGroupForm.jsx